/**
     * @desc 删除作品集
collection内有NFT时不允许删除
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/collection/deleteCollection', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/collection/deleteCollection', params);
}
